import React from 'react';
import { Badge } from 'primereact/badge';

const gNavItems = [
    { icon: 'pi pi-user', badge: 302, active: true },
    { icon: 'pi pi-inbox', badge: 0 },
    { icon: 'pi pi-comments', badge: 1 },
    // { icon: 'pi pi-circle-fill', gradient: true },
    // { icon: 'pi pi-star', badge: 0 },
    // { icon: 'pi pi-trash', badge: 0 },
    // { icon: 'pi pi-cog', badge: 0 },
];

export default function SidebarNav() {
    return (
        <div className="sidebar-container h-screen flex flex-column py-3 bg-primary border-right-1 border-gray-800">
            <div className="flex flex-column align-items-center mb-5">
                {gNavItems.slice(0, 4).map((pItem, pIndex) => (
                    <div
                        key={pIndex}
                        className={
                            `sidebar-item flex align-items-center justify-content-center p-2 my-2 cursor-pointer relative ` +
                            (pItem.active ? 'sidebar-item-active' : '')
                        }
                    >
                        {pItem.icon && !pItem.gradient && (
                            <i
                                className={
                                    `${pItem.icon} text-xl ` +
                                    (pItem.active ? 'text-green-800' : 'text-green-900')
                                }
                            ></i>
                        )}

                        {pItem.gradient && (
                            <div className="gradient-circle w-2rem h-2rem border-circle flex align-items-center justify-content-center"></div>
                        )}

                        {/* {pItem.badge > 0 && (
                            <Badge
                                value={pItem.badge > 99 ? '99+' : pItem.badge}
                                severity="success"
                                className="sidebar-badge"
                            />
                        )} */}

                        {pItem.active && <div className="active-indicator bg-green-500"></div>}
                    </div>
                ))}
            </div>

            <div className="flex flex-column align-items-center mt-5">
                {gNavItems.slice(4).map((pItem, pIndex) => (
                    <div
                        key={`bottom-${pIndex}`}
                        className={
                            `sidebar-item flex align-items-center justify-content-center p-1 cursor-pointer relative ` +
                            (pItem.active ? 'sidebar-item-active' : '')
                        }
                    >
                        {pItem.icon && (
                            <i
                                className={
                                    `${pItem.icon} text-xl ` +
                                    (pItem.active ? 'text-white' : 'text-400')
                                }
                            ></i>
                        )}

                        {/* {pItem.badge > 0 && (
                            <Badge
                                value={pItem.badge > 99 ? '99+' : pItem.badge}
                                severity="success"
                                className="sidebar-badge"
                            />
                        )} */}

                        {pItem.active && <div className="active-indicator bg-green-500"></div>}
                    </div>
                ))}
            </div>
        </div>
    );
}
